import points, { ratingPoints } from '@/content/services/CareLevelCalculator/points';
import content from '@/content/services/CareLevelCalculator/modules';
import { mapFieldsCareLevelCalculator } from '@/store/mapFields';

import {
  CARELEVEL_UPDATE_ANSWER,
  CARELEVEL_UPDATE_INPUT_VALUES,
  CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS,
  CARELEVEL_UPDATE_OVERVIEW_INPUT_VALUE,
} from '@/store/actions/careLevelCalculator';

export default {
  computed: {
    ...mapFieldsCareLevelCalculator([
      'activeWizardAnswers',
      'activeCounterInputValues',
      'modulePoints',
      'wizardIsFinished',
      'calculatedCareLevel',
      'calculatedCareLevelAt',
      'overViewRadioButtons',
      'activeCounterOverviewInputValue',
      'currentWizardUserValue',
    ]),

    calculatedModulePoints() {
      const p = [];
      const backendObject = {};
      this.activeWizardAnswers.map((modulArray, modulIndex) => {
        p[modulIndex] = {
          normal: 0,
          gewichtet: 0,
        };

        // Sonderfall Modul 5
        if (modulIndex === 4) {
          let question1To7 = 0;
          let question8To11 = 0;
          let question12Or15 = 0;
          let question13Or14 = 0;
          let question16 = 0;
          modulArray.map((userSelection, modulArrayIndex) => {
            let textForBackendItem = '';
            const is1To7 = modulArrayIndex >= 0 && modulArrayIndex < 7;
            const is8To11 = modulArrayIndex >= 7 && modulArrayIndex < 11;
            const is12Or15 = modulArrayIndex === 11 || modulArrayIndex === 14;
            const is13Or14 = modulArrayIndex === 12 || modulArrayIndex === 13;
            const is16 = modulArrayIndex === 15;

            if (is16) {
              question16 += userSelection;
              textForBackendItem =
                content[modulIndex].questions[modulArrayIndex].answers[userSelection] || '';
            } else {
              const suffix =
                userSelection > 0 ? `${this.activeCounterInputValues[modulArrayIndex]}x ` : '';
              const c = content[modulIndex].questions[modulArrayIndex].answers[userSelection] || '';
              textForBackendItem = `${suffix}${c}`;
            }

            // täglich
            if (userSelection === 1) {
              if (is1To7) {
                question1To7 += this.activeCounterInputValues[modulArrayIndex];
              }

              if (is8To11) {
                question8To11 += this.activeCounterInputValues[modulArrayIndex];
              }

              if (is12Or15) {
                question12Or15 += this.activeCounterInputValues[modulArrayIndex] * 60;
              }
            }

            // wöchentlich
            if (userSelection === 2) {
              if (is1To7) {
                question1To7 += this.activeCounterInputValues[modulArrayIndex] / 7;
              }

              if (is8To11) {
                question8To11 += this.activeCounterInputValues[modulArrayIndex] / 7;
              }

              if (is12Or15) {
                question12Or15 += this.activeCounterInputValues[modulArrayIndex] * 8.6;
              }

              if (is13Or14) {
                question13Or14 += this.activeCounterInputValues[modulArrayIndex] * 4.3;
              }
            }

            // monatlich
            if (userSelection === 3) {
              if (is1To7) {
                question1To7 += this.activeCounterInputValues[modulArrayIndex] / 30;
              }

              if (is8To11) {
                question8To11 += this.activeCounterInputValues[modulArrayIndex] / 30;
              }

              if (is12Or15) {
                question12Or15 += this.activeCounterInputValues[modulArrayIndex] * 2;
              }

              if (is13Or14) {
                question13Or14 += this.activeCounterInputValues[modulArrayIndex];
              }
            }

            backendObject[`modul${modulIndex + 1}_${modulArrayIndex + 1}`] = textForBackendItem;
          });
          p[modulIndex].normal =
            this.getPointsForQuestion1To7(question1To7) +
            this.getPointsForQuestion8To11(question8To11) +
            this.getPointsForQuestion12To15(question12Or15) +
            this.getPointsForQuestion12To15(question13Or14) +
            question16;
        } else {
          modulArray.map((userSelection, modulArrayIndex) => {
            if (userSelection !== null) {
              const idx = points[modulIndex][modulArrayIndex][userSelection];
              backendObject[`modul${modulIndex + 1}_${modulArrayIndex + 1}`] =
                content[modulIndex].questions[modulArrayIndex].answers[userSelection];
              p[modulIndex].normal += idx;
            }
          });
        }

        const match = ratingPoints[modulIndex].filter(
          (rp) => p[modulIndex].normal >= rp.from && p[modulIndex].normal <= rp.to
        )[0];

        p[modulIndex].gewichtet = match.gewichtet;
      });

      const path = 'careLevelCalculator.wizard.moduleOverview';
      const suffix = '_0_overview';

      this.overViewRadioButtons.map((overViewRadioButtons, modulIndex) => {
        if (overViewRadioButtons) {
          backendObject[`modul${modulIndex + 1}${suffix}`] = [];

          if (modulIndex === 4) {
            Object.keys(overViewRadioButtons || {}).forEach((k, i) => {
              const label = this.$t(`${path}.${modulIndex + 1}`)[i].radiobuttons[
                overViewRadioButtons[k]
              ].label;
              backendObject[`modul${modulIndex + 1}${suffix}`].push(
                `${
                  overViewRadioButtons[k] > 0 ? `${this.activeCounterOverviewInputValue[k]}x ` : ''
                }${label}`
              );
            });
          } else {
            const label = this.$t(`${path}.${modulIndex + 1}`)[0].radiobuttons[
              overViewRadioButtons[0]
            ].label;
            backendObject[`modul${modulIndex + 1}${suffix}`].push(label);
          }
        }
      });

      return { modulePoints: p, backendObject };
    },
  },
  methods: {
    loadWizardDataFromUserValue() {
      const {
        activeWizardAnswers,
        overViewRadioButtons,
        activeCounterInputValues,
        activeCounterOverviewInputValue,
      } = this.currentWizardUserValue;

      activeWizardAnswers?.forEach((answers, currentModule) => {
        answers.map((answer, question) => {
          this.$store.dispatch(CARELEVEL_UPDATE_ANSWER, {
            currentModule,
            question,
            index: answer,
          });
        });
      });

      overViewRadioButtons?.forEach((answers, currentModule) => {
        Object.keys(answers || {}).forEach((contentIdx) => {
          this.$store.dispatch(CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS, {
            currentModule,
            contentIdx,
            value: answers[contentIdx],
          });
        });
      });

      activeCounterInputValues?.forEach((answer, index) => {
        this.$store.dispatch(CARELEVEL_UPDATE_INPUT_VALUES, {
          question: index,
          value: answer,
        });
      });

      activeCounterOverviewInputValue?.forEach((answer, index) => {
        this.$store.dispatch(CARELEVEL_UPDATE_OVERVIEW_INPUT_VALUE, {
          contentIdx: index,
          value: answer,
        });
      });
    },

    getPointsForQuestion1To7(value) {
      /**
       * "value" is the day value
       */
      if (value < 1) {
        return 0;
      } else if (value >= 1 && value <= 3) {
        return 1;
      } else if (value > 3 && value <= 8) {
        return 2;
      } else {
        return 3;
      }
    },

    getPointsForQuestion8To11(value) {
      /**
       * "value" is the day value
       */
      if (value >= 3) {
        return 3;
      } else if (value >= 1 && value < 3) {
        return 2;
      } else if (value >= 1 / 7 && value < 1) {
        return 1;
      } else {
        return 0;
      }
    },

    getPointsForQuestion12To15(value) {
      /**
       * "value" is the day value
       */
      if (value >= 0 && value < 4.3) {
        return 0;
      } else if (value >= 4.3 && value < 8.6) {
        return 1;
      } else if (value >= 8.6 && value < 12.9) {
        return 2;
      } else if (value >= 12.9 && value < 60) {
        return 3;
      } else {
        return 6;
      }
    },

    getCalculatedCareLevel(usingDataFromCurrentCalculation = false) {
      /**
       * Wenn wizardIsFinished = true, dann hole die Modulpunkte aus dem Store,
       * anderenfalls werden die berechneten Punkte anhand des activeWizardAnswers berechnet
       */

      const modulPunkte =
        this.wizardIsFinished && !usingDataFromCurrentCalculation
          ? this.modulePoints
          : this.calculatedModulePoints.modulePoints;

      /**
       * Modul 2 und 3 werden "zusammengelegt"
       * Das Modul mit dem höheren Wert wird
       * in der Berechnung berücksichtigt.
       */
      let ignore2Or3 = 1;
      if (modulPunkte[1].gewichtet > modulPunkte[2].gewichtet) {
        ignore2Or3 = 2;
      }

      let gewichtetePunkte = 0;
      modulPunkte.map((mp, i) => {
        if (i !== ignore2Or3) {
          gewichtetePunkte += mp.gewichtet;
        }
      });

      /**
       * Siehe Tabelle 2 in Confluence
       */
      let pflegegrad = this.wizardIsFinished ? 0 : null;
      if (gewichtetePunkte >= 12.5 && gewichtetePunkte < 27) {
        pflegegrad = 1;
      } else if (gewichtetePunkte >= 27 && gewichtetePunkte < 47.5) {
        pflegegrad = 2;
      } else if (gewichtetePunkte >= 47.5 && gewichtetePunkte < 70) {
        pflegegrad = 3;
      } else if (gewichtetePunkte >= 70 && gewichtetePunkte < 90) {
        pflegegrad = 4;
      } else if (gewichtetePunkte >= 90 && gewichtetePunkte <= 100) {
        pflegegrad = 5;
      }

      return { gewichtetePunkte, pflegegrad };
    },
  },
};
